import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/salary",
      name: "salary",
      meta: { requiresAuth: true, title: "routes.salary" },
      component: () => import("./main.vue"),
    },
  ],
};
